import { Component } from "@angular/core";
import { LegalPageComponent } from "../legal-page/legal-page.component";
import { COOKIE } from "../data/cookie-policy.data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-cookies-policy",
  imports: [LegalPageComponent],
  templateUrl: "./cookies-policy.component.html",
})
export class CookiesPolicyComponent {
  sections = COOKIE;
  appName = environment.appName

  introKey = `<p class="mb-2">ยินดีต้อนรับสู่ <span class="text-primary fw-bold">${this.appName || 'Wise'}</span>
                    ใช้คุกกี้และเทคโนโลยีที่มีลักษณะคล้ายคลึงกันบนเว็บไซต์
                    เพื่อช่วยให้เว็บไซต์สามารถทำงานได้อย่างเหมาะสม เพิ่มประสิทธิภาพการให้บริการ วิเคราะห์การใช้งาน
                    และนำเสนอเนื้อหาหรือการสื่อสารที่เหมาะสมกับผู้ใช้งาน
                    <br />
                    นโยบายการใช้คุกกี้ฉบับนี้อธิบายถึงประเภทของคุกกี้ที่เราใช้ วัตถุประสงค์ในการใช้
                    และวิธีที่ผู้ใช้งานสามารถจัดการคุกกี้ได้</p>`
}
